import { IOrganizacao } from "../../../Interfaces/Organizacao/Organizacao";
import {
    EditarInformacaoService,
    getInfoOrganizacaoService,
} from "../../../Services/Geral/InformacaoOrganizacao/InformacoesOrganizacaoServices";
import { Controller } from "../../Controller";

export function getInfoOrganizacaoServiceController() {
    return Controller(getInfoOrganizacaoService());
}

export function EditarInformacaoController(organizacao: IOrganizacao) {
    return Controller(EditarInformacaoService(organizacao));
}
